import React from 'react';

import MeetingContent from './components/MeetingContent';
import MeetingDate from './components/MeetingDate';
import { BodyContainer } from './styles';

interface MeetingBodyProps {
  title: string;
  content: string;
  location: string;
  date: string;
  time: string;
  tags: string[];
}
const MeetingBody: React.FC<MeetingBodyProps> = ({
  title,
  content,
  location,
  date,
  tags,
  time,
}) => {
  return (
    <>
      <BodyContainer>
        <MeetingContent
          title={title}
          content={content}
          location={location}
          tags={tags}
        />
        <MeetingDate date={date} time={time} />
      </BodyContainer>
    </>
  );
};

export default MeetingBody;
